import React from 'react';
import './Spinner.css'

export const Spinner = (props) => (
    <div className={`MSD-Loader ${(props.className) ? props.className : ''}`}>
        <div className="lds-roller"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
    </div>
);
